/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loading } from '@redux/actions';
import { useEffect, useState } from 'react';
import { Application } from '../../../..';
import Routes from '@applications/billing/route-constants';
import { Data } from '@telstra-connect/utils';
import { BillingLayoutComponent } from '@applications/billing/components/billing-layout';
import TextStyle from '@able/react/dist/TextStyle';
import Spacing from '@able/react/dist/Spacing';
import { useLocation, useNavigate } from 'react-router-dom';
import MessageTemplate from 'ted-ui/build/MessageTemplate';
import { ILoadDDAggrement, SubscribedState } from '../direct-debit/interfaces';
import { loadExistingDDAgreementMethod } from '@telstra-connect/billing/methods/load-dd-agreement';
import { getCidn, getCompanyName, getCorrectCardDetail } from '@utils/common-functions';
import Grid from '@able/react/dist/Grid';
import { RemoveDirectDebitInitial } from '@telstra-connect/billing/actions/remove-direct-debit';
const ddSuccessful = require('../../../../../../images/enquiry-confirmation.svg');
const iconDevelopmentURL = require('../../../../../../images/able/able-sprites.svg');

export const SuccessPageDirectDebit = () => {
    const location = useLocation();
    const messageMap = {
        setup: 'added',
        update: 'updated',
        cancel: 'cancelled'
    }
    const TC_BILLING_ACC_ID = 'TC:billing:accID';
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [from, setFrom] = useState('');
    const [showPaymentTypeLast4Digit, setPaymentTypeLast4Digit] = useState('');
    const [isDirectDebitSuccess, setDirectDebitSuccess] = useState(false);
    const cidn = getCidn();
    const CompanyName = getCompanyName();
    const accountId = JSON.parse(sessionStorage.getItem(TC_BILLING_ACC_ID))?.value;
    const { paymentAgreement } = useSelector((state: SubscribedState): ILoadDDAggrement => ({
        paymentAgreement: state.billing.ddAgreement,
    }));
    useEffect(() => {
        dispatch(loadExistingDDAgreementMethod(cidn, accountId))
        dispatch(loading(true))
        return () => dispatch(RemoveDirectDebitInitial())
    }, []);

    useEffect(() => {
        if (location.state && location.state.from) {
            setFrom(location.state.from)
        }
    }, [location.state]);

    useEffect(() => {
        const hasPaymentAgreementRecieved = Data.requestSucceeded(paymentAgreement);
        const hasPaymentAgreementStarted = Data.requestStarted(paymentAgreement);
        if (hasPaymentAgreementStarted) {
            setDirectDebitSuccess(true)
            setPaymentTypeLast4Digit('')
        } else if (hasPaymentAgreementRecieved) {
            setDirectDebitSuccess(true)
            const { data } = paymentAgreement;
            const last4Digit = data
                && data.paymentAgreements?.[0].paymentMethod?.last4;
            const cardType = data
                && data.paymentAgreements?.[0].paymentMethod?.cardType;
            data && data.paymentAgreements &&
            setPaymentTypeLast4Digit(`${getCorrectCardDetail(cardType).title} ending in ${last4Digit}`);
        }
    }, [paymentAgreement]);

    const goBacktoPaymentMethodsPage = () => {
        navigate(Application.routes.getPageSubpath(Routes.PaymentMethods));
    }

    return (isDirectDebitSuccess &&
        <BillingLayoutComponent>
            <Grid padding={false}>
                <MessageTemplate
                    content={<>
                        <TextStyle element="p">
                            {`Payments will ${from === 'cancel' ? 'no longer ' : ''}be automatically processed
                            on your invoice due date.`}
                        </TextStyle>
                        <Spacing bottom="spacing3x"/>
                        <TextStyle element="p">Company</TextStyle>
                        <TextStyle element="p">{CompanyName}</TextStyle>
                        <Spacing bottom="spacing3x"/>
                        <TextStyle element="p">Billing account</TextStyle>
                        <TextStyle element="p">{accountId}</TextStyle>
                        {from !== 'cancel' && <>
                            <Spacing bottom="spacing3x"/>
                            <TextStyle element="p">Payment method</TextStyle>
                            <TextStyle element="p">{showPaymentTypeLast4Digit}</TextStyle>
                        </>}
                    </>}
                    imageSrc={ddSuccessful}
                    primaryButton={{
                        element: 'button',
                        label: 'Back to payment methods',
                        variant: 'LowEmphasis',
                        developmentUrl: iconDevelopmentURL,
                        icon: 'ChevronLeft',
                        events: {onClick: goBacktoPaymentMethodsPage}
                    }}
                    title={`Direct debit ${messageMap[from]}`}
                    titleHeadingOrder={1} />
            </Grid>
        </BillingLayoutComponent>
    )
}
